import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CloseCircle = ({ className }) => {
  return (
    <svg
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-close-circle', { [className]: className })}
    >
      <circle cx='10' cy='10' r='9.5' stroke='currentColor' />
      <line x1='6.11137' y1='6.13863' x2='13.8895' y2='13.9168' stroke='currentColor' />
      <line x1='13.8887' y1='6.13871' x2='6.11054' y2='13.9169' stroke='currentColor' />
    </svg>
  );
};

CloseCircle.propTypes = {
  className: PropTypes.string,
};

export default CloseCircle;
